import React, { Component } from 'react'
import InvoiceTable from './invoiceTable'
import InvoiceEmailHistory from './invoiceEmailHistory'
import Container from '../common/application_container'

export default class InvoiceIndex extends Component {
    constructor(props) {
        super(props)
        this.state = { activeTab: 'invoices' }
    }

    render() {
        const { activeTab } = this.state
        return (
            <Container title="Invoice">
                {/* Tab bar */}
                <div style={{
                    display: 'flex',
                    gap: '4px',
                    borderBottom: '1px solid #E2E8F0',
                    marginBottom: '24px',
                    background: '#fff',
                    padding: '0 4px',
                    borderRadius: '12px 12px 0 0',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
                }}>
                    {[
                        { key: 'invoices',      label: 'Invoices',      icon: 'icon-file-text2' },
                        { key: 'emailHistory',  label: 'Email History', icon: 'icon-envelop'    },
                    ].map(tab => (
                        <button
                            key={tab.key}
                            onClick={() => this.setState({ activeTab: tab.key })}
                            style={{
                                display: 'flex', alignItems: 'center', gap: '6px',
                                padding: '12px 18px',
                                fontSize: '13px',
                                fontWeight: activeTab === tab.key ? '600' : '500',
                                color: activeTab === tab.key ? '#047857' : '#475569',
                                background: 'transparent',
                                border: 'none',
                                borderBottom: activeTab === tab.key ? '2px solid #10B981' : '2px solid transparent',
                                cursor: 'pointer',
                                marginBottom: '-1px',
                                transition: 'all 150ms ease',
                            }}
                        >
                            <i className={tab.icon} style={{ fontSize: '13px' }}></i>
                            {tab.label}
                        </button>
                    ))}
                </div>

                {activeTab === 'invoices'     && <InvoiceTable />}
                {activeTab === 'emailHistory' && <InvoiceEmailHistory />}
            </Container>
        )
    }
}
